<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Implantar
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Como listar documentos prontos para implantação e concluir a
        strong  implantação
        |  (PAF, observação e revisão).

      .toast.toast-primary
        | Listar exige
        strong  Fiscalização → Implantações de documentos → Listar
        | . Implantar exige
        strong  Fiscalização → Implantações de documentos → Implantar
        | .

      h5.h5 1. Abrir Implantar
      ol
        li Em
          strong  Doc
          | , clique em
          strong  Implantar
          | .
      figure.manual-figure
        img(:src="imgLista" alt="Listagem Documentos para implantar")
      p A tabela mostra número/ano, tipo, cadastro, situação, data de autuação,
        |  fiscal e valor. Use filtros e paginação conforme necessário.

      h5.h5 2. Abrir o formulário
      ol
        li Na linha desejada, clique no ícone
          strong  Implantar
          |  (olho).
      figure.manual-figure
        img(:src="imgForm" alt="Formulário Implantar documento")
      ol
        li Confira os dados do documento no topo.
        li Preencha
          strong  PAF
          |  (se aplicável) e
          strong  Observação do lançamento
          |  (obrigatório).
        li (Opcional) Ative
          strong  Revisado
          |  e informe protocolo/observação da revisão.
        li Clique em
          strong  Implantar
          | .
      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/15-doc-implantar-lista.png"),
      imgForm: require("@/assets/manuais/15a-doc-implantar-form.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
